export default "/build/images/sp.png?acb6fa260fdb729c32ae2eaad0c0056d";